/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import {useTranslation} from 'react-i18next'
import LeadOffersList from './LeadOffersList'
import {currencyNumberFormat} from 'utils/utility'
import type {Offer} from 'types/entities/Offer'
import type {Lead} from 'types/entities/Lead'

interface EditLeadOffersTabProps {
    selectedLead: Lead
    offersCount: number
    offersMinRevenue: number
    offersMaxRevenue: number
    effectiveOffers: Offer[]
}

const EditLeadOffersTab: React.FC<EditLeadOffersTabProps> = ({
    selectedLead,
    offersCount,
    offersMinRevenue,
    offersMaxRevenue,
    effectiveOffers,
}) => {
    const {t} = useTranslation()

    return (
        <div className="EditLeadOffersTab flex-1 flex flex-col pt-4 overflow-hidden">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6 shrink-0">
                <div className="bg-white dark:bg-gray-900 p-4 rounded-xl border border-gray-100 dark:border-gray-800 shadow-sm">
                    <div className="text-gray-500 dark:text-gray-400 text-xs font-medium uppercase tracking-wider mb-1">
                        {t('Total Offers')}
                    </div>
                    <div className="text-2xl font-bold text-gray-900 dark:text-white">
                        {offersCount ?? 0}
                    </div>
                </div>
                <div className="bg-white dark:bg-gray-900 p-4 rounded-xl border border-gray-100 dark:border-gray-800 shadow-sm">
                    <div className="text-gray-500 dark:text-gray-400 text-xs font-medium uppercase tracking-wider mb-1">
                        {t('Revenue (Min)')}
                    </div>
                    <div className="text-2xl font-bold text-gray-900 dark:text-white">
                        {currencyNumberFormat(offersMinRevenue)}
                    </div>
                </div>
                <div className="bg-white dark:bg-gray-900 p-4 rounded-xl border border-gray-100 dark:border-gray-800 shadow-sm">
                    <div className="text-gray-500 dark:text-gray-400 text-xs font-medium uppercase tracking-wider mb-1">
                        {t('Revenue (Max)')}
                    </div>
                    <div className="text-2xl font-bold text-gray-900 dark:text-white">
                        {currencyNumberFormat(offersMaxRevenue)}
                    </div>
                </div>
            </div>
            <LeadOffersList leadId={selectedLead.id} offers={effectiveOffers} />
        </div>
    )
}

export default EditLeadOffersTab
